import {
  LIST_WORKFLOWS_ROUTE,
  GET_WORKFLOW_BY_ID_ROUTE,
  LIST_WORKFLOW_RUNS_ROUTE,
  GET_WORKFLOW_RUN_BY_ID_ROUTE,
  CREATE_WORKFLOW_RUN_ROUTE,
  STREAM_WORKFLOW_ROUTE,
  RESUME_STREAM_WORKFLOW_ROUTE,
  START_ASYNC_WORKFLOW_ROUTE,
  START_WORKFLOW_RUN_ROUTE,
  OBSERVE_STREAM_WORKFLOW_ROUTE,
  RESUME_ASYNC_WORKFLOW_ROUTE,
  RESUME_NO_WAIT_WORKFLOW_ROUTE,
  RESUME_WORKFLOW_ROUTE,
  CANCEL_WORKFLOW_RUN_ROUTE,
  TIME_TRAVEL_WORKFLOW_ROUTE,
  TIME_TRAVEL_STREAM_WORKFLOW_ROUTE,
  RESTART_WORKFLOW_ROUTE,
  RESTART_ASYNC_WORKFLOW_ROUTE,
  RESTART_ALL_ACTIVE_WORKFLOW_RUNS_ROUTE,
  RESTART_ALL_ACTIVE_WORKFLOW_RUNS_ASYNC_ROUTE,
  TIME_TRAVEL_ASYNC_WORKFLOW_ROUTE,
  DELETE_WORKFLOW_RUN_BY_ID_ROUTE,
  EXECUTE_WORKFLOW_STEP_ROUTE,
  RECEIVE_WORKFLOW_EVENT_ROUTE,
} from '../../handlers/workflows';

export const WORKFLOWS_ROUTES = [
  LIST_WORKFLOWS_ROUTE,
  GET_WORKFLOW_BY_ID_ROUTE,
  LIST_WORKFLOW_RUNS_ROUTE,
  GET_WORKFLOW_RUN_BY_ID_ROUTE,
  DELETE_WORKFLOW_RUN_BY_ID_ROUTE,
  CREATE_WORKFLOW_RUN_ROUTE,
  STREAM_WORKFLOW_ROUTE,
  RESUME_STREAM_WORKFLOW_ROUTE,
  START_ASYNC_WORKFLOW_ROUTE,
  START_WORKFLOW_RUN_ROUTE,
  OBSERVE_STREAM_WORKFLOW_ROUTE,
  RESUME_ASYNC_WORKFLOW_ROUTE,
  RESUME_NO_WAIT_WORKFLOW_ROUTE,
  RESUME_WORKFLOW_ROUTE,
  CANCEL_WORKFLOW_RUN_ROUTE,
  TIME_TRAVEL_WORKFLOW_ROUTE,
  TIME_TRAVEL_ASYNC_WORKFLOW_ROUTE,
  TIME_TRAVEL_STREAM_WORKFLOW_ROUTE,
  RESTART_WORKFLOW_ROUTE,
  RESTART_ASYNC_WORKFLOW_ROUTE,
  RESTART_ALL_ACTIVE_WORKFLOW_RUNS_ROUTE,
  RESTART_ALL_ACTIVE_WORKFLOW_RUNS_ASYNC_ROUTE,
  EXECUTE_WORKFLOW_STEP_ROUTE,
  RECEIVE_WORKFLOW_EVENT_ROUTE,
] as const;
